import TeamSelection from "./TeamSelection";

export default function CompetitionTeamSelection() {
  return (
    <TeamSelection
      entityType="competition"
      title="Select Competition Teams"
      listEndpoint="/api/competitions"
      teamsEndpoint="/api/competitions/competitions/:id/teams/"
    />
  );
}
